import { axios } from './axios.js';

export const getModelByRefId = async referenceID => {
  const res = await axios.get(
    `/reconstruction/model/specific/details?referenceID=${referenceID}`,
  );
  return res.data;
};

export const getModelByReconId = async reconstructionID => {
  const res = await axios.get(
    `/reconstruction/model/specific/details?reconstructionID=${reconstructionID}`,
  );
  return res.data;
};

export const renameModel = async (reconstructionID, newModelName) => {
  try {
    const res = await axios.patch('/reconstruction', {
      reconstructionID,
      newModelName,
    });
    return res.data;
  } catch (error) {
    console.warn('Rename model error', error);
    toast.error('Failed to rename model');
    throw error;
  }
};
